<template>
  <div class="notifications">
    <template v-for="notes in notifications" :key="notes.id">
      <div :id="'note-' + notes.id" :class="'notification priority-' + notes.acf.priority">
        <div class="svg-icon" v-if="notes.acf.priority == 'info'">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 25px; height: 25px;">
            <path
              d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
          </svg>
        </div>

        <div class="svg-icon" v-if="notes.acf.priority !== 'info'">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 25px; height: 25px;">
            <path
              d="M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z" />
          </svg>
        </div>
        <div>
          <strong v-html="notes.title.rendered"></strong>
          <span v-html="notes.content.rendered"></span>
        </div>
        <a class="close" @click="closeNotification(notes.id)">
          <svg
            class="close-icon"
            style="width: 1.5em; height: 1.5em; vertical-align: middle; fill: currentColor; overflow: hidden"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M557.2 512l136.4-136.4c12.4-12.4 12.4-32.8 0-45.2-12.4-12.4-32.8-12.4-45.2 0L512 466.8l-136.4-136.4c-12.4-12.4-32.8-12.4-45.2 0-6.2 6.2-9.4 14.4-9.4 22.6 0 8.2 3.2 16.4 9.4 22.6l136.4 136.4-136.4 136.4c-6.2 6.2-9.4 14.4-9.4 22.6 0 8.2 3.2 16.4 9.4 22.6 12.4 12.4 32.8 12.4 45.2 0l136.4-136.4 136.4 136.4c12.4 12.4 32.8 12.4 45.2 0 12.4-12.4 12.4-32.8 0-45.2L557.2 512z"
              fill="" />
          </svg>
        </a>
      </div>
    </template>
  </div>   

  <ComponentStyles>
    .notifications{ position: absolute; max-width: 400px; min-width: 200px; right: 20px; top: 20px; z-index: 1020; font-size: 14px !important;
    animation-name: fadein; animation-duration: 1s; } .priority-info{ border-left: 5px solid #02547E; background: linear-gradient(to right, #E4F9F6,
    #ffffff); fill: #02547E; } .priority-warning{ border-left: 5px solid #9B4202; background: linear-gradient(to right, #FFF2E3, #ffffff); fill:
    #9B4202; } .priority-danger{ border-left: 5px solid #9E0C3D; background: linear-gradient(to right, #F5D7E1, #ffffff); fill: #9E0C3D; }
    .notification{ box-shadow: 0 .375em 1em rgba(0,0,0,.06); margin-bottom: 0.5rem!important; margin: 0px 0px 5px 0px !important; padding: 1rem 1.5rem
    1rem 1rem; position: relative; background-color: #fff; border-radius: 0.25rem; grid-template-columns: 42px 1fr; column-gap: 1em; display: grid;}
    .notification .svg-icon{ border-radius: 42px; height: 42px; width: 42px;align-items: center; display: flex; justify-content: center; background: #fff;
    box-shadow: 0 .375em 1em rgba(0,0,0,.06); } .notification p{ margin: 0px !important; font-size: 12px !important; } .close{ position: absolute;
    top: 0px; right: 0px; } @keyframes fadein { 0% { opacity: 0; -webkit-transform: translate3d(0,-100%,0); transform: translate3d(0,-100%,0) } to {
    opacity: 1; -webkit-transform: translateZ(0); transform: translateZ(0) } }
    @media screen and (max-width: 600px) {
      .notification{ display: block;}
      .notification .svg-icon{ margin-bottom: 6px;}
    }
  </ComponentStyles>
</template>

<script>
import VueCookies from "vue-cookies";
import ComponentStyles from "../componentStyles.vue";

export default {
  props: ["site"],
  components: { ComponentStyles },
  data() {
    return {
      notifications: [],
      timeNow: Date.now() / 1000,
      currentPath: window.location.pathname,
    };
  },

  methods: {
    fetchQuestions() {
      fetch("https://apps.gavleenergi.se/powerplant-webservice/servicepoint/notifications/")
        .then((res) => res.json())
        .then((json) => {
          console.log(this.currentPath);

          //Kollar site, "bäst-före-datum" samt om det finns specificerad sökväg för hämtade meddelanden.
          json.map((note) => {
            if (note.acf.type.indexOf("crisis") != -1 && note.acf.crisis_site) {
              if (
                note.acf.crisis_site.indexOf(this.site) != -1 &&
                this.checkIfClosed(note.id) == false &&
                this.convertTime(note.acf.expiration_date) > this.timeNow
              ) {
                if (note.acf.path != "") {
                  let patharray = note.acf.path.split(",");
                  if (patharray.indexOf(this.currentPath) != -1) {
                    this.notifications.push(note);
                  }
                } else {
                  this.notifications.push(note);
                }
              }
            }
          });
        });
    },

    closeNotification(noteId) {
      document.getElementById("note-" + noteId).remove();

      VueCookies.set("note-" + noteId, "closed");
    },

    checkIfClosed(noteId) {
      if (VueCookies.get("note-" + noteId)) {
        return true;
      } else return false;
    },

    convertTime(uglyDate) {
      //I de fall inget bäst-före-datum är satt.
      if (uglyDate == "") {
        return this.timeNow * 2;
      }

      const [dateComponents, timeComponents] = uglyDate.split(" ");
      //console.log(dateComponents); // 👉️ "06/26/2022"
      //console.log(timeComponents); // 👉️ "04:35:12"

      const [year, month, day] = dateComponents.split("/");
      const [hours, minutes] = timeComponents.split(":");

      const date = new Date(+year, month - 1, +day, +hours, +minutes);
      //console.log(date); // 👉️ Sun Jun 26 2022 04:35:12

      const timestampInSeconds = Math.floor(date.getTime() / 1000);
      //console.log(this.timeNow)
      //console.log(timestampInSeconds); // 👉️ 1650080712

      return timestampInSeconds;
    },
  },
  mounted() {
    this.fetchQuestions();
  },
};
</script>
